import React from "react";
import DOMPurify from "dompurify";
import PaytrCardForm from "./PaytrCardForm";

class PaymentStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPaymentMethod: "online", // transfer | online
      comment: "",
      agreedToTerms: true, // Varsayılan olarak işaretli
      showModal: false,
      modalContent: "",
      modalTitle: "",
    };
    this.paytrCardFormRef = React.createRef();
  }

  componentDidMount() {
    // İlk ödeme yöntemini parent'a bildir
    if (this.props.onPaymentChange) {
      this.props.onPaymentChange({
        method: this.state.selectedPaymentMethod,
      });
    }
  }

  handlePaymentMethodChange = (method) => {
    this.setState({ selectedPaymentMethod: method }, () => {
      if (this.props.onPaymentChange) {
        this.props.onPaymentChange({
          method: this.state.selectedPaymentMethod,
        });
      }
    });
  };

  handleCommentChange = (e) => {
    this.setState({ comment: e.target.value });
  };

  handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    this.setState({ [name]: checked });
  };

  openModal = (e, pageSlug, title) => {
    e.preventDefault();
    // Sayfayı fetch et ve modal'da göster
    const query = "query={getAllPagesData{id,slug,content_title,content}}";
    fetch("/graphql?" + query)
      .then((res) => res.json())
      .then((result) => {
        if (result.data && result.data.getAllPagesData) {
          const page = result.data.getAllPagesData.find(
            (p) => p.slug === pageSlug
          );
          if (page) {
            this.setState({
              showModal: true,
              modalContent: page.content,
              modalTitle: page.content_title || title,
            });
          }
        }
      })
      .catch((error) => {
        console.error("Sayfa yüklenirken hata:", error);
      });
  };

  closeModal = () => {
    this.setState({ showModal: false, modalContent: "", modalTitle: "" });
  };

  validate = () => {
    const { selectedPaymentMethod, agreedToTerms } = this.state;

    if (!agreedToTerms) {
      alert("Lütfen sözleşmeleri onaylayınız");
      return false;
    }

    // Online ödeme seçiliyse kart bilgilerini kontrol et
    if (selectedPaymentMethod === "online" && this.paytrCardFormRef.current) {
      const cardData = this.paytrCardFormRef.current.getCardData();
      if (!cardData) {
        return false;
      }
    }

    return true;
  };

  getCardData = () => {
    if (
      this.state.selectedPaymentMethod === "online" &&
      this.paytrCardFormRef.current
    ) {
      return this.paytrCardFormRef.current.getCardData();
    }
    return null;
  };

  getComment = () => {
    return this.state.comment;
  };

  render() {
    const {
      selectedPaymentMethod,
      comment,
      agreedToTerms,
      showModal,
      modalContent,
      modalTitle,
    } = this.state;
    const { payments } = this.props;

    // Admin panelden gelen ödeme yöntemleri
    const transferPayment =
      payments && payments.find((p) => p.method === "transfer");
    const onlinePayment =
      payments && payments.find((p) => p.method === "online");

    return (
      <div>
        {/* Ödeme Yöntemleri */}
        <div style={styles.paymentMethods}>
          {/* Kredi Kartı / Online Ödeme */}
          {onlinePayment && (
            <div
              style={{
                ...styles.paymentCard,
                ...(selectedPaymentMethod === "online"
                  ? styles.selectedPaymentCard
                  : {}),
              }}
              onClick={() => this.handlePaymentMethodChange("online")}
            >
              <div style={styles.paymentHeader}>
                <div style={styles.radioWrapper}>
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="online"
                    checked={selectedPaymentMethod === "online"}
                    onChange={() => this.handlePaymentMethodChange("online")}
                    style={styles.radio}
                  />
                </div>
                <h6 style={styles.paymentTitle}>Kredi Kartı</h6>
              </div>

              <div style={styles.paymentContent}>
                {/* PayTR Kart Formu */}
                {selectedPaymentMethod === "online" && (
                  <PaytrCardForm ref={this.paytrCardFormRef} />
                )}
              </div>
            </div>
          )}

          {/* Havale / EFT */}
          {transferPayment && (
            <div
              style={{
                ...styles.paymentCard,
                ...(selectedPaymentMethod === "transfer"
                  ? styles.selectedPaymentCard
                  : {}),
              }}
              onClick={() => this.handlePaymentMethodChange("transfer")}
            >
              <div style={styles.paymentHeader}>
                <div style={styles.radioWrapper}>
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="transfer"
                    checked={selectedPaymentMethod === "transfer"}
                    onChange={() => this.handlePaymentMethodChange("transfer")}
                    style={styles.radio}
                  />
                </div>

                <h6 style={styles.paymentTitle}>Havale / EFT</h6>
              </div>

              <div style={styles.paymentContent}>
                {/* Havale Bilgileri */}
                {selectedPaymentMethod === "transfer" && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(transferPayment.content),
                    }}
                    style={styles.transferContent}
                  />
                )}
              </div>
            </div>
          )}
        </div>

        <hr style={styles.divider} />

        {/* Sipariş Notu */}
        <div className="form-group">
          <label style={styles.label}>Sipariş Notu (Opsiyonel)</label>
          <textarea
            name="comment"
            value={comment}
            onChange={this.handleCommentChange}
            className="form-control"
            rows="3"
            placeholder="Siparişiniz hakkında not ekleyebilirsiniz"
          ></textarea>
        </div>

        <hr style={styles.divider} />

        {/* Sözleşmeler */}
        <div style={styles.agreementsSection}>
          <div className="form-group">
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input"
                id="agreedToTerms"
                name="agreedToTerms"
                checked={agreedToTerms}
                onChange={this.handleCheckboxChange}
              />
              <label className="custom-control-label" htmlFor="agreedToTerms">
                <a
                  href="#"
                  onClick={(e) =>
                    this.openModal(
                      e,
                      "mesafeli-satis-sozlesmesi",
                      "Mesafeli Satış Sözleşmesi"
                    )
                  }
                  style={styles.link}
                >
                  Mesafeli Satış Sözleşmesini
                </a>{" "}
                ve{" "}
                <a
                  href="#"
                  onClick={(e) =>
                    this.openModal(
                      e,
                      "gizlilik-ve-cerez-politikasi",
                      "Gizlilik ve Çerez Politikası"
                    )
                  }
                  style={styles.link}
                >
                  Gizlilik ve Çerez Politikası
                </a>
                'nı okudum, onaylıyorum.
              </label>
            </div>
          </div>
        </div>

        {/* Modal */}
        {showModal && (
          <div style={styles.modalOverlay} onClick={this.closeModal}>
            <div
              style={styles.modalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={styles.modalHeader}>
                <h4 style={styles.modalTitle}>{modalTitle}</h4>
                <button
                  type="button"
                  style={styles.modalClose}
                  onClick={this.closeModal}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>
              <div
                style={styles.modalBody}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(modalContent) }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const styles = {
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#1a1d1f",
    marginBottom: "18px",
  },
  paymentMethods: {
    marginBottom: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  paymentCard: {
    border: "1px solid #E5E4E9",
    borderRadius: "12px",
    padding: "16px",
    cursor: "pointer",
    display: "flex",
    alignItems: "flex-start",

    transition: "all 0.2s ease",
    backgroundColor: "#ffffff",
    flexDirection: "column",
  },
  selectedPaymentCard: {
    borderColor: "#84b817",
    backgroundColor: "#f7f7f9",
    boxShadow: "0 0 0 1px #84b817",
  },
  radioWrapper: {
    paddingTop: "6px",
  },
  radio: {
    width: "22px",
    height: "22px",
    cursor: "pointer",
    accentColor: "#5f8d00",
  },
  paymentContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
  },
  paymentHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
  },
  paymentTitle: {
    fontSize: "16px",
    fontWeight: "normal",
    color: "#1a1d1f",
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: "10px",
    paddingTop: "4px",
  },
  paymentIcon: {
    color: "#84b817",
    fontSize: "20px",
  },
  paymentDesc: {
    fontSize: "14px",
    color: "#6f7a8d",
    margin: 0,
  },
  cardLogos: {
    display: "flex",
    gap: "12px",
  },
  cardLogo: {
    height: "26px",
    objectFit: "contain",
  },
  cardFormWrapper: {
    marginTop: "8px",
    padding: "18px 20px",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    border: "1px dashed #d9dee8",
  },
  transferInfo: {
    marginTop: "8px",
    padding: "18px 20px",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    border: "1px dashed #d9dee8",
  },
  transferContent: {
    marginTop: "15px",
    fontSize: "14px",
    color: "#4c566a",
    lineHeight: 1.6,
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#4c566a",
    marginBottom: "6px",
  },
  divider: {
    margin: "28px 0",
    border: 0,
    borderTop: "1px solid #e6eaf2",
  },
  agreementsSection: {
    marginTop: "28px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  link: {
    color: "#84b817",
    textDecoration: "none",
    fontWeight: "600",
  },
  required: {
    color: "#dc3545",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10000,
    padding: "20px",
  },
  modalContent: {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    maxWidth: "800px",
    width: "100%",
    maxHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
  },
  modalHeader: {
    padding: "24px 28px",
    borderBottom: "1px solid #e6eaf2",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modalTitle: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "600",
    color: "#1a1d1f",
  },
  modalClose: {
    background: "transparent",
    border: "none",
    fontSize: "24px",
    color: "#6f7a8d",
    cursor: "pointer",
    padding: "0",
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    transition: "all 0.2s ease",
  },
  modalBody: {
    padding: "28px",
    overflowY: "auto",
    fontSize: "14px",
    lineHeight: "1.8",
    color: "#4c566a",
  },
};

export default PaymentStep;



// WEBPACK FOOTER //
// ./src/components/PaymentStep.js